import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
const PROGRESSION = ['Global Webinar', 'UK Localized Episodes', 'Episodic Campaigns', 'Anzupgo Funnel'];
interface SlideProps {
  index: number;
  total: number;
}
export function Slide1UKTitle({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-black" data-id="element-33">
      {/* Hero image with cinematic overlay */}
      <div className="absolute inset-0" data-id="element-34">
        <motion.img src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=1920&q=80" alt="Confident dermatologist in a white coat" className="w-full h-full object-cover" initial={{
        scale: 1.08
      }} animate={{
        scale: 1
      }} transition={{
        duration: 8,
        ease: 'easeOut'
      }} data-id="element-35" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/30" data-id="element-36" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-black/40" data-id="element-37" />
      </div>

      {/* Thin brand rule top */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-1 bg-[var(--brand-green)] origin-left z-20" data-id="element-38" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-39">
        <div className="max-w-5xl" data-id="element-40">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-41">
            <span className="h-px w-10 bg-[var(--brand-green-lighter)]" data-id="element-42" />
            <p className="text-[var(--brand-green-lighter)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-semibold uppercase tracking-[0.25em]" data-id="element-43">
              DERMX&nbsp;&nbsp;|&nbsp;&nbsp;LEO Pharma UK
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-white font-bold text-[clamp(2.75rem,6.5vw,6rem)] leading-[0.98] tracking-tight mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-44">
            UK Localization
            <br data-id="element-45" />
            <span className="text-[var(--brand-green-lighter)]" data-id="element-46">
              &amp; Engagement
            </span>
            <br data-id="element-47" />
            <span className="text-[var(--brand-green-lighter)]" data-id="element-48">Strategy</span>
          </motion.h1>

          {/* Subline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="text-white/85 text-[clamp(1.1rem,1.7vw,1.5rem)] font-medium max-w-2xl leading-snug mb-[clamp(1.75rem,3vw,2.5rem)]" data-id="element-49">
            Turn global webinars into localized UK episodes to generate
            top-of-funnel engagement and build a seamless pathway to branded
            Anzupgo activities.
          </motion.p>

          {/* Progression chip */}
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.75,
          duration: 0.55
        }} className="inline-flex flex-wrap items-center gap-x-3 gap-y-2 bg-white/[0.07] backdrop-blur-md border border-white/15 rounded-full px-[clamp(1rem,2vw,1.75rem)] py-[clamp(0.65rem,1.2vw,1rem)]" data-id="element-50">
            {PROGRESSION.map((step, i) => <Fragment key={step} data-id="element-51">
                <span className="text-white font-semibold text-[clamp(0.8rem,1.2vw,1.05rem)]" data-id="element-52">
                  {step}
                </span>
                {i < PROGRESSION.length - 1 && <span className="text-[var(--brand-green-lighter)] text-lg leading-none" data-id="element-53">
                    →
                  </span>}
              </Fragment>)}
          </motion.div>
        </div>
      </div>

      {/* Bottom statement */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 hidden md:block" data-id="element-54">
        <p className="text-white/70 text-[clamp(0.95rem,1.4vw,1.2rem)] font-medium border-l-2 border-[var(--brand-green)] pl-4 max-w-xl" data-id="element-55">
          One global webinar can become a localized UK content franchise.
        </p>
      </motion.div>
    </div>;
}